import 'fetch-polyfill';
import API from '../../APIconfig';

import {
  UPDATE_NAME,
  UPDATED_MOBILE_NUMBER,
  UPDATE_PROFILE_PASSWORD,
} from './userConstants';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import {
  toastr
} from 'react-redux-toastr';

import { getUserDetails } from '../auth/AuthActions';

/**
 * action: updateName
 * @description Update user's first and last name
 * @param {string} firstName 
 * @param {string} lastName 
 * @param {string} csrfRequestIdentifier 
 */
export const updateName = (firstName, lastName, csrfRequestIdentifier, email, user) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Updating name . . .', false, 'updatename'));
      const reqObject = {
        method: API.user.updateProfileName.method,
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({
          firstName,
          lastName
        }),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const name = await fetch(API.user.updateProfileName.url, reqObject).then(response => response.json());

      if (name.success) {
        dispatch(getUserDetails(email, user));
        toastr.success('User Profile', 'Successfully updated user name');
      } else {
        toastr.error('User Profile', 'Error while updating user name');
      }

      dispatch({
        type: UPDATE_NAME,
        payload: name,
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
}

export const updatedMobileNumber = () => {
  toastr.success('User Profile', 'Successfully updated');
  return {
    type: UPDATED_MOBILE_NUMBER,
  }
};

export const updateProfilePassword = (password, newPassword, csrfRequestIdentifier, callback) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Updating password . . .', true, 'updateprofilepassword'));
      const reqObject = {
        method: API.user.updateProfilePassword.method,
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({
          password,
          newPassword
        }),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const update = await fetch(API.user.updateProfilePassword.url, reqObject).then(response => response.json());

      if (update.errorCode) {
        toastr.error('Change Password', update.errorMessage);
      }

      if (update.success) {
        toastr.success('Change Password', 'Password changed successfully');
      }
      

      dispatch({
        type: UPDATE_PROFILE_PASSWORD,
        payload: update,
      });
      dispatch(asyncActionFinish());

      callback();
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
}